import { FormControl, LoadingButton } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useAddressBookFormContext } from '../hooks';

export function Actions() {
  const { formState } = useAddressBookFormContext();
  const { t } = useTranslation();

  return (
    <FormControl.SubmitButton asChild>
      <LoadingButton loading={formState.isSubmitting} type="submit">
        {t('common.save')}
      </LoadingButton>
    </FormControl.SubmitButton>
  );
}
